import { useEffect } from 'react';

import {
  setAllLocations,
  setAllCompanies,
  setSelectedLocations,
  setSelectedCompanies,
} from 'Deer/intent/Reviews/slice/ReviewsIntentSlice';
import { useDispatch } from 'react-redux';
import { checkEnableCompanySupport } from 'utils/helpers/featureFlags';

export const useSetCompanyMetaFilterInitialData = (reviewsManageData) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const rowsDataBeforeFilters = reviewsManageData?.rows || [];

    if (checkEnableCompanySupport()) {
      const companiesMap = {};
      rowsDataBeforeFilters?.forEach((row) => {
        if (row?.COMPANY?.id && !companiesMap[row?.COMPANY?.id]) {
          companiesMap[row?.COMPANY?.id] = row?.COMPANY;
        }
      });

      dispatch(setAllCompanies(Object.keys(companiesMap)?.map((key) => companiesMap[key])));
      dispatch(setSelectedCompanies(Object.keys(companiesMap)?.map((key) => companiesMap[key])));
    }
  }, [dispatch, reviewsManageData?.rows]);
};

export const useSetLocationMetaFilterInitialData = (reviewsManageData) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const rowsDataBeforeFilters = reviewsManageData?.rows || [];

    if (checkEnableCompanySupport()) {
      const locationsMap = {};

      rowsDataBeforeFilters?.forEach((row) => {
        if (row?.LOCATION && !locationsMap[row?.LOCATION?.toLowerCase()]) {
          locationsMap[row?.LOCATION?.toLowerCase()] = row?.LOCATION;
        }
      });

      dispatch(setSelectedLocations(Object.keys(locationsMap)?.map((key) => locationsMap[key])));
      dispatch(setAllLocations(Object.keys(locationsMap)?.map((key) => locationsMap[key])));
    }
  }, [dispatch, reviewsManageData?.rows]);
};
